<template>
  <div>
    <AllPopUp ref="pop"></AllPopUp>
  </div>
</template>
<script>
import AllPopUp from '@/components/AllPopUp'
export default {
  data () {
    return {
      show: false
    }
  },
  methods: {
    showPopUp () {
      console.log(this.$refs.pop.showNotify())
    }
  },
  mounted () {
    // Notify({ type: 'danger', message: '通知内容' })
    this.showPopUp()
  },
  components: {
    AllPopUp
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
